import React, { useState, useRef, useEffect } from "react";
import { maps, kordinatKoka } from "../../helper";
import {
	MapContent,
	MapLogo,
	PopUpLocation,
	ReactMapGLKoka,
} from "./Map.Styles";
import { Marker, Popup } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const Map = () => {
	const [viewPort, setViewPort] = useState({
		latitude: kordinatKoka.latitude,
		longitude: kordinatKoka.longitude,
		zoom: 14,
		minZoom: 11,
		maxZoom: 18,
	});

	const [showPopup, togglePopup] = React.useState(false);
	const ref = useRef(null);

	const handleClickOutside = event => {
		if (ref.current && !ref.current.contains(event.target)) {
			togglePopup(false);
		}
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	});

	useEffect(() => {
		if (!showPopup) return;
		const escFunction = event => {
			if (showPopup && event.keyCode === 27) {
				togglePopup(false);
			}
		};
		document.addEventListener("keydown", escFunction, false);
		return () => {
			document.removeEventListener("keydown", escFunction, false);
		};
	}, [showPopup]);

	return (
		<MapContent id="maps">
			<h1>Find Us</h1>
			<ReactMapGLKoka
				mapStyle="mapbox://styles/mapbox/dark-v10"
				onViewportChange={viewport => setViewPort(viewport)}
				mapboxApiAccessToken={maps}
				{...viewPort}
				width="100%"
				height="100%"
			>
				<Marker
					latitude={kordinatKoka.latitude}
					longitude={kordinatKoka.longitude}
					offsetLeft={-20}
					offsetTop={-10}
				>
					<MapLogo
						src={process.env.PUBLIC_URL + `/img/MapMarker.png`}
						alt="set"
						width={viewPort.zoom * 3}
						height={viewPort.zoom * 4}
						onClick={() => {
							if (togglePopup === true) return;
							togglePopup(true);
						}}
					/>
				</Marker>

				{showPopup && (
					<Popup
						latitude={kordinatKoka.latitude}
						longitude={kordinatKoka.longitude}
						closeButton={true}
						closeOnClick={false}
						onClose={() => togglePopup(false)}
						anchor="bottom-left"
						offsetLeft={20}
						offsetTop={10}
					>
						<PopUpLocation
							onClick={e => console.log(e.target)}
							ref={ref}
						>
							<h2>Teras Seduh Koka</h2>
							<p>Jalan Sukapura No 76</p>
							<a
								href="https://www.google.com/maps/dir/?api=1&destination=Teras+Seduh+Koka,+Jalan+Adhyaksa+Raya,+Sukapura,+Bandung+City,+West+Java/"
								target="_blank"
								rel="noopener noreferrer"
							>
								{" "}
								Direction
							</a>
						</PopUpLocation>
					</Popup>
				)}
			</ReactMapGLKoka>
		</MapContent>
	);
};

export default Map;
